import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';

import { MarqueeRow, ShowcaseItem } from '@/components/home/ShowcaseMarquee';

const MEDIA = 'https://media.easy-peasy.ai/landing/video';
const HOME = 'https://media.easy-peasy.ai/landing/home';
const ASSETS = 'https://media.easy-peasy.ai/assets';
const TPL = '/ai-video-generator/templates';

const ROW_A: ShowcaseItem[] = [
  {
    src: `${ASSETS}/seedance2_hero.mp4`,
    poster: `${HOME}/seedance2_hero-poster.jpg`,
    video: true,
    aspect: '16/9',
    label: 'Seedance 2.0',
    href: '/ai-video-generator/seedance-2',
  },
  {
    src: `${ASSETS}/news-anchor.mp4`,
    poster: `${HOME}/news-anchor-poster.jpg`,
    video: true,
    aspect: '1/1',
    label: 'Talking avatars',
    href: '/ai-video-generator/talking',
  },
  {
    src: `${MEDIA}/fashion-vertical.mp4`,
    poster: `${MEDIA}/fashion-vertical-poster.jpg`,
    video: true,
    aspect: '9/16',
    label: 'Fashion film',
    href: '/ai-videos',
  },
  {
    src: `${HOME}/vid-neoncity.mp4`,
    poster: `${HOME}/vid-neoncity-poster.jpg`,
    video: true,
    aspect: '16/9',
    label: 'Night scenes',
    href: '/ai-videos',
  },
  {
    src: `${ASSETS}/motion-control-800-v2.mp4`,
    poster: `${HOME}/motion-control-800-v2-poster.jpg`,
    video: true,
    aspect: '3/4',
    label: 'Motion control',
    href: `${TPL}/change-character-in-scene`,
  },
  {
    src: `${HOME}/vid-butterfly.mp4`,
    poster: `${HOME}/vid-butterfly-poster.jpg`,
    video: true,
    aspect: '16/9',
    label: 'Nature film',
    href: '/ai-videos',
  },
  {
    src: `${ASSETS}/talking-vegetables-800.mp4`,
    poster: `${HOME}/talking-vegetables-800-poster.jpg`,
    video: true,
    aspect: '3/4',
    label: 'Characters',
    href: `${TPL}/workflow-talking-vegetables`,
  },
];

const ROW_B: ShowcaseItem[] = [
  {
    src: `${HOME}/vid-perfume.mp4`,
    poster: `${HOME}/vid-perfume-poster.jpg`,
    video: true,
    aspect: '16/9',
    label: 'Product ads',
    href: `${TPL}/workflow-product-commercial`,
  },
  {
    src: `${MEDIA}/travel-vertical.mp4`,
    poster: `${MEDIA}/travel-vertical-poster.jpg`,
    video: true,
    aspect: '9/16',
    label: 'Travel reels',
    href: '/ai-videos',
  },
  {
    src: `${ASSETS}/stadium-kiss-800.mp4`,
    poster: `${HOME}/stadium-kiss-800-poster.jpg`,
    video: true,
    aspect: '3/4',
    label: 'Kiss cam',
    href: `${TPL}/valentine-kiss-cam`,
  },
  {
    src: `${HOME}/vid-coast.mp4`,
    poster: `${HOME}/vid-coast-poster.jpg`,
    video: true,
    aspect: '16/9',
    label: 'Cinematic drone',
    href: '/ai-videos',
  },
  {
    src: `${ASSETS}/0208-800.mp4`,
    video: true,
    aspect: '3/4',
    label: 'Viral dance',
    href: `${TPL}/viral-dance-motion-control`,
  },
  {
    src: `${HOME}/vid-portrait.mp4`,
    poster: `${HOME}/vid-portrait-poster.jpg`,
    video: true,
    aspect: '9/16',
    label: 'Portrait film',
    href: '/ai-videos',
  },
  {
    src: `${ASSETS}/original_08281374-eeb8-4a49-9411-93d3fa0f2c72.mp4`,
    video: true,
    aspect: '3/4',
    label: 'Miniature worlds',
    href: `${TPL}/miniature-finger-frame`,
  },
];

const VideoShowcaseRows = () => {
  const { t } = useLocale('ai-videos');

  return (
    <section id='showcase' className='relative overflow-hidden py-20 lg:py-28'>
      <div className='mx-auto mb-12 flex max-w-7xl flex-col items-start justify-between gap-6 px-4 sm:px-6 md:flex-row md:items-end lg:px-8'>
        <div>
          <h2 className='text-4xl font-extrabold tracking-tight text-white md:text-5xl'>
            {t('Every frame here is AI')}
          </h2>
          <p className='mt-4 max-w-xl text-lg text-slate-400'>
            {t(
              'Straight out of the generator — no post-production. Click any clip to start from its template.',
            )}
          </p>
        </div>
        <Link
          href='/ai-videos'
          className='shrink-0 rounded-full border border-white/15 bg-white/5 px-6 py-3 font-semibold text-white transition-all hover:border-white/40 hover:bg-white/10'
        >
          {t('Open the generator')} →
        </Link>
      </div>

      <div className='flex flex-col gap-4'>
        <MarqueeRow items={ROW_A} duration={85} />
        <MarqueeRow items={ROW_B} duration={100} reverse />
      </div>
    </section>
  );
};

export default VideoShowcaseRows;
